import { useSelector } from 'react-redux';
import { Grid, Typography } from '@methanesat/ui-components';
import { useTranslate } from '../../../../../hooks';
import { selectEmissionsMapFilters } from '../../../../../reducers';
import type { RootState } from '../../../../../store';
import { useGetOgiNearPointDrawer } from '../../DataSpecific';
import { OGI_NEAR_RASTER_RADIUS_M } from '../../../../../consts';

export const OGITitle = ({ source, longitude, latitude }: { source?: string; longitude: number; latitude: number }) => {
    const t = useTranslate();

    // Nearby OGI info (number of nearby facilities)
    const { ogiSummary } = useGetOgiNearPointDrawer({ longitude, latitude });
    const ogiCount = Object.values(ogiSummary).reduce((acc, curr) => (acc += curr), 0);
    const ogiTitle = t('emissionsMapPage.infrastructure.ogiNearEmissions.nearbyFacilitiesTitle', { count: ogiCount });

    const showOgiDetails = useSelector((state: RootState) => selectEmissionsMapFilters(state).ogimFeatures.length > 0);

    const dispersedOgiSubtitle = t(
        'emissionsMapPage.infrastructure.ogiNearEmissions.common.nearbyFacilitiesDistanceNote',
        {
            radiusMeters: OGI_NEAR_RASTER_RADIUS_M,
            sourceType: t('emissionsMapPage.infrastructure.ogiNearEmissions.sourceType.dispersed')
        }
    );

    //subtitle is hidden when ogi details are visible
    const pointSourceOgiSubtitle = showOgiDetails
        ? ''
        : t('emissionsMapPage.infrastructure.ogiNearEmissions.common.uncertaintyNote');

    const ogiSubtitle = source === 'dispersed' ? dispersedOgiSubtitle : pointSourceOgiSubtitle;

    return (
        <Grid>
            <Grid size={{ xs: 12 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{ogiTitle}</Typography>
            </Grid>

            <Grid size={{ xs: 12 }} display="flex" marginTop={1}>
                <Typography variant="body2">{ogiSubtitle}</Typography>
            </Grid>
        </Grid>
    );
};
